export const PRODUCT_TYPES = {
  UNIT: 1,
  COMBO: 2
}

export const PRODUCT_KINDS = {
  PLANNING: 1,
  MANUFACTURE: 2
}

export const QUANTITY_OPTIONS = {
  CASE: 1,
  ARCH: 2,
  TOOTH: 3
}

// Desconto fixo aplicado ao preço do combo (soma dos produtos internos),
// deve bater com Product::COMBO_DISCOUNT_PERCENTAGE no backend.
export const COMBO_DISCOUNT_PERCENTAGE = 10

export const getQtdOptionLabel = (qtdOption) => {
  const entry = Object.entries(QUANTITY_OPTIONS).find(([, value]) => value === qtdOption)
  return entry ? entry[0] : null
}

export const getProductKindLabel = (productKind) => {
  const entry = Object.entries(PRODUCT_KINDS).find(([, value]) => value === productKind)
  return entry ? entry[0] : null
}

export const getProductTypeLabel = (productType) => {
  const entry = Object.entries(PRODUCT_TYPES).find(([, value]) => value === productType)
  return entry ? entry[0] : null
}

export class ProductLang {
  constructor() {
    this.name = null
    this.description = null
    this.price = 0
    this.discount = 0
    this.publish = false
  }

  static FromObj(obj) {
    const instance = new ProductLang()
    
    instance.name = obj.name || null
    instance.description = obj.description || null
    instance.price = obj.price || 0
    instance.discount = obj.discount || 0
    instance.publish = obj.publish || false
    
    return instance
  }

  toFormData() {
    return {
      name: this.name || null,
      description: this.description || null,
      price: this.price || 0,
      discount: this.discount || 0,
      publish: this.publish || false
    }
  }
}

export class Product {
  constructor() {
    this.category = null
    this.code = null
    this.createdAt = null
    this.dataEn = new ProductLang()
    this.dataEs = new ProductLang()
    this.dataPtBr = new ProductLang()
    this.id = null
    this.image = null
    this.kindName = null
    this.manufactureTime = 0
    this.fileProtocols = []
    this.priceEn = null
    this.priceEs = null
    this.pricePtBr = null
    this.namePtBr = null
    this.nameEn = null
    this.nameEs = null
    this.productData = []
    this.productKind = null
    this.productType = null
    this.publishEn = false
    this.publishEs = false
    this.publishPtBr = false
    this.qtdMax = 0
    this.qtdOption = null
    this.qtdOptionName = null
    this.requiresManufacture = false
    this.askBdsPrinting = false
    this.serviceDataDefault = []
    this.typeName = null
    this.updatedAt = null
    this.alignment = false
    this.enableKit = false
    this.enableSleeve = false
    this.enableR2 = false
    this.innerProducts = []
    
    // this.favorite = false
    // this.kindOfManufacture = 1
    // this.quantity = 1
    // this.innerCheckoutProducts = []
  }

  static FromObj(obj) {
    const instance = new Product()
    console.log('obj', obj)
    
    instance.category = obj.category || null
    instance.code = obj.code || null
    instance.createdAt = obj.created_at || null
    instance.dataEn = obj.data_en || null
    instance.dataEs = obj.data_es || null
    instance.dataPtBr = obj.data_pt_br || null
    instance.id = obj.id || null
    instance.image = obj.image || null
    instance.kindName = obj.kind_name || obj.kindName || null
    instance.manufactureTime = obj.manufacture_time || obj.manufactureTime || 0
    instance.fileProtocols = obj.file_protocol || obj.file_protocols || obj.fileProtocols || []
    instance.priceEn = obj.price_en || null
    instance.priceEs = obj.price_es || null
    instance.pricePtBr = obj.price_pt_br || null
    instance.namePtBr = obj.namePtBr || null
    instance.nameEn = obj.nameEn || null
    instance.nameEs = obj.nameEs || null
    instance.productData = obj.product_data || null
    // Manter os valores numéricos originais em vez de converter para string
    instance.productKind = obj.product_kind || obj.productKind || null
    instance.productType = obj.product_type || obj.productType || null
    instance.publishEn = obj.publish_en || false
    instance.publishEs = obj.publish_es || false
    instance.publishPtBr = obj.publish_pt_br || false
    instance.qtdMax = obj.qtd_max || obj.qtdMax || 0
    instance.qtdOption = obj.qtd_option || obj.qtdOption || null
    instance.qtdOptionName = obj.qtd_option_name || obj.qtdOptionName || null
    instance.requiresManufacture = obj.requires_manufacture || obj.requiresManufacture || false
    instance.askBdsPrinting = obj.ask_bds_printing ?? obj.askBdsPrinting ?? false
    instance.serviceDataDefault = obj.service_data_default || obj.serviceDataDefault || null
    instance.typeName = obj.type_name || obj.typeName || null
    instance.updatedAt = obj.updated_at || obj.updatedAt || null
    instance.alignment = obj.alignment || false
    instance.enableKit = obj.enable_kit || obj.enableKit || false
    instance.enableSleeve = obj.enable_sleeve || obj.enableSleeve || false
    instance.enableR2 = obj.enable_r2 || obj.enableR2 || false

    // Adicionar campos que estão vindo da API mas não estavam sendo mapeados
    instance.name = obj.name || null
    instance.description = obj.description || null
    instance.shortDescription = obj.shortDescription || null
    instance.price = obj.price || 0
    instance.discount = obj.discount || 0
    instance.currency = obj.currency || 'pt_BR'
    instance.published = obj.published || false
    instance.features = obj.features || []
    instance.specifications = obj.specifications || []
    instance.images = obj.images || []
    // Preservar objeto prices da API (formato: { pt_BR, en, es })
    instance.prices = obj.prices || null
    // Resumo dos produtos internos do combo (nome/foto/qtd, sem preço)
    instance.comboContents = obj.comboContents || []

    // // Dados restantes.
    // instance.kindOfManufacture = obj.kind_of_manufacture
    // instance.comboData = obj.combo_data || null
    // instance.manufactureData = obj.manufacture_data || null
    // instance.quantity = obj.quantity || 1
    // instance.innerCheckoutProducts = obj.inner_checkout_products || []
    
    return instance
  }

  toFormData() {
    const formData = {
      id_category: this.category,
      code: this.code,
      created_at: this.createdAt,
      id: this.id,
      kind_name: this.kindName,
      manufacture_time: this.manufactureTime,
      file_protocol: this.fileProtocols,
      product_data: this.productData,
      product_kind: this.productKind,
      product_type: this.productType,
      qtd_max: this.qtdMax,
      qtd_option: this.qtdOption,
      qtd_option_name: this.qtdOptionName,
      requires_manufacture: this.requiresManufacture,
      ask_bds_printing: this.askBdsPrinting,
      service_data_default: this.serviceDataDefault,
      type_name: this.typeName,
      updated_at: this.updatedAt,
      data_pt_br: this.dataPtBr,
      price_pt_br: this.pricePtBr,
      data_en: this.dataEn,
      price_en: this.priceEn,
      data_es: this.dataEs,
      price_es: this.priceEs,
      alignment: this.alignment,
      enable_kit: this.enableKit,
      enable_sleeve: this.enableSleeve,
      enable_r2: this.enableR2
    }

    // Adicionar inner_products se existir (para produtos combo)
    if (this.innerProducts && this.innerProducts.length > 0) {
      formData.inner_products = this.innerProducts
    }

    // Incluir image se houver um valor válido (File object ou string) ou se for explicitamente null
    if (this.image !== undefined) {
      if (this.image instanceof File) {
        // Para File objects, vamos criar um FormData
        const multipartFormData = new FormData()
        
        // Adicionar todos os campos do produto
        Object.keys(formData).forEach(key => {
          if (typeof formData[key] === 'object' && formData[key] !== null) {
            multipartFormData.append(key, JSON.stringify(formData[key]))
          } else {
            multipartFormData.append(key, formData[key])
          }
        })
        
        // Adicionar a imagem como arquivo
        multipartFormData.append('image', this.image)
        
        return multipartFormData
      } else {
        // Se é uma string (URL/path) ou null, incluir diretamente
        formData.image = this.image
      }
    }

    return formData
  }
}

// export class ProductShopCheckout {
//   constructor(data = {}) {
//     this.cartProductId = data.cartProductId || 0
//     this.productPlanningId = data.productPlanningId || 0
//     this.productManufactureId = data.productManufactureId || 0
    
//     this.qtdOpt = data.qtdOpt || 0
//     this.quantity = data.quantity || 0
    
//     this.planningExtraData = data.planningExtraData || {}
    
//     // Dados de manufatura
//     this.manufactureData = data.manufactureData || {
//       sleevesManufacture: 0,
//       sleevesQtd: 0
//     }
//   }

//   static FromObj(obj) {
//     return new ProductShopCheckout(obj)
//   }

//   // Identificador único no carrinho
//   id() {
//     return `${this.productPlanningId}:${this.qtdOpt}:${this.quantity}`
//   }

//   // Validações
//   isSettedSleeveManufacturer() {
//     return !!this.manufactureData.sleevesManufacture
//   }

//   isSleeveQtdValid() {
//     return this.manufactureData.sleevesQtd > 0
//   }

//   isValid() {
//     return this.productPlanningId > 0 && this.quantity > 0
//   }

//   // Métodos utilitários
//   getTotalPrice(product) {
//     if (!product) return 0
    
//     return product.getFinalPrice() * this.quantity
//   }

//   canIncreaseQuantity(product) {
//     if (!product) return false
    
//     return product.canAddQuantity(this.quantity + 1)
//   }

//   increaseQuantity() {
//     this.quantity++
//   }

//   decreaseQuantity() {
//     if (this.quantity > 1) {
//       this.quantity--
//     }
//   }

//   setQuantity(quantity) {
//     this.quantity = Math.max(1, quantity)
//   }
// }

// export class ProductCategory {
//   constructor() {
//     this.id = 0
//     this.name = ''
//     this.description = ''
//     this.icon = ''
//     this.color = ''
//     this.active = true
//     this.order = 0
//     this.createdAt = null
//     this.updatedAt = null
//   }

//   static FromObj(obj) {
//     const instance = new ProductCategory()
    
//     instance.id = obj.id
//     instance.name = obj.name || ''
//     instance.description = obj.description || ''
//     instance.icon = obj.icon || ''
//     instance.color = obj.color || ''
//     instance.active = obj.active || true
//     instance.order = obj.order
//     instance.createdAt = obj.createdAt || null
//     instance.updatedAt = obj.updatedAt || null
    
//     return instance
//   }

//   isActive() {
//     return this.active
//   }

//   getDisplayName() {
//     return this.name
//   }

//   toFormData() {
//     return {
//       id: this.id,
//       name: this.name,
//       description: this.description,
//       icon: this.icon,
//       color: this.color,
//       active: this.active,
//       order: this.order
//     }
//   }
// }

// export class ComboData {
//   constructor() {
//     this.totalPrice = 0
//     this.totalManufactureTime = 0
//     this.requiredItems = []
//     this.optionalItems = []
//   }

//   static FromObj(obj) {
//     const instance = new ComboData()
    
//     instance.totalPrice = obj.totalPrice
//     instance.totalManufactureTime = obj.totalManufactureTime
//     instance.requiredItems = obj.requiredItems || []
//     instance.optionalItems = obj.optionalItems || []
    
//     return instance
//   }

//   getTotalPrice() {
//     return this.totalPrice
//   }

//   getRequiredItems() {
//     return this.requiredItems
//   }

//   getOptionalItems() {
//     return this.optionalItems
//   }

//   getAllItems() {
//     return [...this.requiredItems, ...this.optionalItems]
//   }
// }

// export class ComboItem {
//   constructor() {
//     this.id = 0
//     this.comboProductId = 0
//     this.includedProduct = null
//     this.quantity = 1
//     this.discountPercentage = 0
//     this.isOptional = false
//     this.displayOrder = 0
//     this.manufactureData = {}
//     this.totalManufactureTime = 0
//     this.currency = 'pt_BR'
//     this.originalPrice = 0
//     this.discountedPrice = 0
//     this.totalPrice = 0
//   }

//   static FromObj(obj) {
//     const instance = new ComboItem()
    
//     instance.id = obj.id
//     instance.comboProductId = obj.comboProductId
//     instance.includedProduct = obj.includedProduct || null
//     instance.quantity = obj.quantity
//     instance.discountPercentage = obj.discountPercentage
//     instance.isOptional = obj.isOptional || false
//     instance.displayOrder = obj.displayOrder
//     instance.manufactureData = obj.manufactureData || {}
//     instance.totalManufactureTime = obj.totalManufactureTime
//     instance.currency = obj.currency || 'pt_BR'
//     instance.originalPrice = obj.originalPrice
//     instance.discountedPrice = obj.discountedPrice
//     instance.totalPrice = obj.totalPrice
    
//     return instance
//   }

//   getDiscountAmount() {
//     return this.originalPrice - this.discountedPrice
//   }

//   hasDiscount() {
//     return this.discountPercentage > 0
//   }
// }

// export class ManufactureData {
//   constructor() {
//     this.id = 0
//     this.productId = 0
//     this.materialType = 0
//     this.materialTypeName = ''
//     this.materialSpecifications = {}
//     this.equipmentRequired = []
//     this.manufacturingSteps = []
//     this.qualityRequirements = {}
//     this.technicalSpecifications = {}
//     this.estimatedTimeHours = 0
//     this.estimatedTimeDays = 0
//     this.complexityLevel = 0
//     this.complexityLevelName = ''
//     this.specialRequirements = []
//     this.toleranceSpecifications = {}
//     this.finishRequirements = {}
//     this.packagingRequirements = {}
//     this.safetyRequirements = []
//     this.totalManufactureTime = 0
//     this.createdAt = null
//     this.updatedAt = null
//   }

//   static FromObj(obj) {
//     const instance = new ManufactureData()
    
//     instance.id = obj.id
//     instance.productId = obj.productId
//     instance.materialType = obj.materialType
//     instance.materialTypeName = obj.materialTypeName || ''
//     instance.materialSpecifications = obj.materialSpecifications || {}
//     instance.equipmentRequired = obj.equipmentRequired || []
//     instance.manufacturingSteps = obj.manufacturingSteps || []
//     instance.qualityRequirements = obj.qualityRequirements || {}
//     instance.technicalSpecifications = obj.technicalSpecifications || {}
//     instance.estimatedTimeHours = obj.estimatedTimeHours
//     instance.estimatedTimeDays = obj.estimatedTimeDays
//     instance.complexityLevel = obj.complexityLevel
//     instance.complexityLevelName = obj.complexityLevelName || ''
//     instance.specialRequirements = obj.specialRequirements || []
//     instance.toleranceSpecifications = obj.toleranceSpecifications || {}
//     instance.finishRequirements = obj.finishRequirements || {}
//     instance.packagingRequirements = obj.packagingRequirements || {}
//     instance.safetyRequirements = obj.safetyRequirements || []
//     instance.totalManufactureTime = obj.totalManufactureTime
//     instance.createdAt = obj.createdAt || null
//     instance.updatedAt = obj.updatedAt || null
    
//     return instance
//   }

//   getEstimatedTimeInDays() {
//     return this.estimatedTimeDays
//   }

//   getEstimatedTimeInHours() {
//     return this.estimatedTimeHours
//   }

//   requiresSpecialHandling() {
//     return this.specialRequirements.length > 0
//   }
// }
